import controller from './oo-admin-kndef.controller';
import template from './oo-admin-kndef.html';
import './oo-admin-kndef.scss';

export default {
	bindings:     {
		disabled: '<?ngDisabled',
		kndef:    '<ngModel',
		options:  '<?',
		type:     '@?',
	},
	controller,
	template,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: 'ngModel',
		parent:      '^^ooAdmin',
	},
};
